import { Area } from "../Area/Area";

export class AreaLegMapping{

    
    constructor(private area:Area,private leg:any){

    }

    public getArea(){

        return this.area;
    }

    public getLeg(){
        
        return this.leg;
    }
}